import { InteractionMode } from 'chart.js';

export const CHART_DATA = {
  datasets: [
    {
      borderWidth: 0,
      cutout: '70%',
      circumference: 180,
      rotation: -90,
      spacing: 15,
    },
  ],
};

export const CHART_OPTIONS = {
  maintainAspectRatio: false,
  interaction: {
    mode: 'index' as InteractionMode,
  },
  plugins: {
    legend: {
      display: false,
    },
    tooltip: {
      bodyFont: {
        size: 14,
      },
      displayColors: false,
      callbacks: {
        label: ({ label, formattedValue, raw }: any) => {
          const percentage = Number(raw).toFixed(
            formattedValue.charAt(2) === 0 ? 2 : 0,
          );
          return `${label} ${percentage}%`;
        },
      },
    },
  },
  layout: {
    autoPadding: false,
  },
};
